/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegioneDTO
 */
export interface RegioneDTO {
    /**
     * 
     * @type {string}
     * @memberof RegioneDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RegioneDTO
     */
    descrizione?: string;
    /**
     * 
     * @type {string}
     * @memberof RegioneDTO
     */
    nazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegioneDTO
     */
    nazione?: string;
}

/**
 * Check if a given object implements the RegioneDTO interface.
 */
export function instanceOfRegioneDTO(value: object): value is RegioneDTO {
    return true;
}

export function RegioneDTOFromJSON(json: any): RegioneDTO {
    return RegioneDTOFromJSONTyped(json, false);
}

export function RegioneDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegioneDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'descrizione': json['descrizione'] == null ? undefined : json['descrizione'],
        'nazioneId': json['nazioneId'] == null ? undefined : json['nazioneId'],
        'nazione': json['nazione'] == null ? undefined : json['nazione'],
    };
}

export function RegioneDTOToJSON(value?: RegioneDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'descrizione': value['descrizione'],
        'nazioneId': value['nazioneId'],
        'nazione': value['nazione'],
    };
}

